<template>
    <article
        class="forum-post"
        v-if="!hasBeenDeleted(post)">

        <ForumAvatar :src="getAuthorAvatar(post.author)">
        </ForumAvatar>

        <div class="post-body">

            <div class="post-meta">
                <div class="post-context">
                    <router-link
                        class="author-name"
                        :to="getAuthorUrl(post.author)">
                        {{ getAuthorName(post.author) }}
                    </router-link>
                    <span
                        class="author-role"
                        v-if="post.author && post.author.roles.length > 0">
                        <img
                            :src="getAuthorRoleIcon(post.author)"
                            :title="getAuthorRole(post.author)">
                        <span>{{ getAuthorRole(post.author) }}</span>
                    </span>
                </div>
                <div class="post-date">
                    <span
                        class="edit-status"
                        :title="editStatus(post)"
                        v-if="hasBeenEdited(post)">
                        <i class="fa fa-pencil"></i>
                    </span>
                    <span :title="postStatus(post)">
                        {{ prettyPostDate(post) }}
                    </span>
                </div>
            </div>

            <div class="post-content">
                <!-- TODO: remove post block stubs and show full post
                     content. -->
                <ForumPostBlock v-if="sourcePost">
                    <template slot="context">
                        <i class="intro-icon fa fa-reply"></i>
                        <span class="intro-text">Reply to</span>
                        <div class="avatar-small">
                            <ForumAvatar
                                :src="getAuthorAvatar(sourcePost.author)">
                            </ForumAvatar>
                        </div>
                        <router-link
                            class="author-name"
                            :to="getAuthorUrl(sourcePost.author)"
                            v-if="sourcePost.author">
                            {{ getAuthorName(sourcePost.author) }}
                        </router-link>
                        <span
                            class="author-name"
                            v-else>
                            {{ getAuthorName(sourcePost.author) }}
                        </span>
                    </template>
                    <template slot="actions">
                        <!--<button>
                            <i class="fa fa-chevron-down"></i>
                        </button>-->
                        <button
                            title="Go to the source post"
                            @click="goToSourcePost()">
                            <i class="fa fa-arrow-up"></i>
                        </button>
                    </template>
                    <!--<div
                        class="post-content-html"
                        v-html="sourcePost.content">
                    </div>-->
                </ForumPostBlock>

                <div
                    class="post-content-html"
                    ref="content"
                    @click="onContentClick"
                    v-html="post.content"
                    v-show="!isEditing"
                    v-if="!hasBeenDeleted(post)">
                </div>
                <div
                    class="post-content-html"
                    v-else>
                    <em>Post has been deleted.</em>
                </div>

                <HtmlEditor
                    class="html-editor"
                    contentClass="post-content-html"
                    ref="editor"
                    :allowEmoji="true"
                    :stickyToolbar="true"
                    :tagMap="{ h1: 'h3', h2: 'h4' }"
                    v-if="isEditing">
                </HtmlEditor>

                <ForumPostBlock
                    theme="success"
                    v-if="answerPost">
                    <!-- TODO: remove post block stubs and show full post
                         content. -->
                    <template slot="context">
                        <i class="intro-icon fa fa-check-square-o"></i>
                        <span class="intro-text">Answered by</span>
                        <div class="avatar-small">
                            <ForumAvatar
                                :src="getAuthorAvatar(answerPost.author)">
                            </ForumAvatar>
                        </div>
                        <router-link
                            class="author-name"
                            :to="getAuthorUrl(answerPost.author)"
                            v-if="answerPost.author">
                            {{ getAuthorName(answerPost.author) }}
                        </router-link>
                        <span
                            class="author-name"
                            v-else>
                            {{ getAuthorName(answerPost.author) }}
                        </span>
                    </template>
                    <template slot="actions">
                        <!--<button v-if="canAnswer">
                            <i class="fa fa-remove"></i>
                        </button>
                        <button>
                            <i class="fa fa-chevron-down"></i>
                        </button>-->
                        <button
                            title="Go to the answer post"
                            @click="goToAnswerPost()">
                            <i class="fa fa-arrow-down"></i>
                        </button>
                    </template>
                    <!--<div
                        class="post-content-html"
                        v-html="answerPost.content">
                    </div>-->
                </ForumPostBlock>
            </div>

            <div class="post-actions">
                <div v-show="!isEditing && !isDeleting">
                    <button
                        :class="{ 'accent-answer': isAnswer }"
                        :title="isAnswer ? 'Unmark as answer' : 'Mark as answer'"
                        @click="toggleAnswer()"
                        v-if="canSolve">
                        <i
                            class="fa fa-check-square"
                            v-if="isAnswer">
                        </i>
                        <i
                            class="fa fa-check-square-o"
                            v-else>
                        </i>
                    </button>
                    <button
                        title="Delete"
                        @click="startDelete()"
                        v-if="canDelete">
                        <i class="fa fa-trash"></i>
                    </button>
                    <button
                        title="Edit"
                        @click="startEdit()"
                        v-if="canEdit">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button
                        title="Reply"
                        @click="startReply()"
                        v-if="canReply">
                        <i class="fa fa-reply"></i>
                    </button>
                    <button
                        :class="{ accent: isLiked }"
                        :title="isLiked ? 'Unlike' : 'Like'"
                        @click="toggleLike()"
                        v-if="canLike">
                        <i
                            class="fa fa-thumbs-up"
                            v-if="isLiked">
                        </i>
                        <i
                            class="fa fa-thumbs-o-up"
                            v-else>
                        </i>
                    </button>
                    <span
                        class="link-share-wrapper"
                        title="Share"
                        v-if="canShare">
                        <button
                            :class="{ 'accent-hover': linkShareShowing }"
                            @click="toggleLinkShare()">
                            <i class="fa fa-link"></i>
                        </button>
                        <ForumShare
                            ref="linkShare"
                            :value="postUrl"
                            @close="closeLinkShare()"
                            v-show="linkShareShowing">
                        </ForumShare>
                    </span>
                </div>

                <div v-show="isEditing">
                    <slot name="saveEditorButton">
                        <button
                            class="btn-primary"
                            @click="saveEdit()">
                            <slot name="saveEditorLabel">
                                Save
                            </slot>
                        </button>
                    </slot>
                    <slot name="stopEditorButton">
                        <button @click="cancelEdit()">
                            <slot name="stopEditorLabel">
                                Cancel
                            </slot>
                        </button>
                    </slot>
                </div>

                <div v-show="isDeleting">
                    <button
                        class="btn-danger"
                        @click="doDelete()">
                        Delete
                    </button>
                    <button @click="cancelDelete()">
                        Cancel
                    </button>
                </div>
            </div>

        </div>

        <LightboxMediaGallery
            :media="lightbox.media"
            :index.sync="lightbox.index"
            :showing.sync="lightbox.showing"
            v-if="lightbox.media.length > 0">
        </LightboxMediaGallery>

    </article>

    <article
        class="forum-post forum-post-deleted"
        v-else-if="hasBeenDeleted(post)">

        <div class="post-body">
            <div class="post-content">
                <div class="post-content-html">
                    <em>Post has been deleted.</em>
                </div>
            </div>

            <div class="post-date">
                <span
                    class="delete-status"
                    :title="deleteStatus(post)">
                    <i class="fa fa-trash"></i>
                </span>
                <span :title="postStatus(post)">
                    {{ prettyPostDate(post) }}
                </span>
            </div>
        </div>

    </article>
</template>

<script>
    // ForumPost: renders a reply within a thread. Allows the user perform
    // various post actions, such as liking, deleting, or sharing the post. Also
    // handles expanding media in a lightbox.

    // Events:
    //  - like
    //  - unlike
    //  - reply
    //  - edit
    //  - cancel
    //  - save
    //  - delete
    //  - solve
    //  - unsolve
    //  - go-answer-post
    //  - go-source-post

    import ForumUtils           from 'src/utils/forum';
    import UserUtils            from 'src/utils/users';
    import HtmlEditor           from '../html-editor';
    import LightboxMediaGallery from '../lightbox/media-gallery';
    import ForumAvatar          from './avatar';
    import ForumPostBlock       from './post-block';
    import ForumShare           from './share';

    export default {

        props: {
            post: {
                type: Object, // ForumPost (see forum service)
                required: true,
            },

            // The post url depends on the thread, so it can't be calculated
            // automatically.
            postUrl: {
                type: String,
            },

            sourcePost: {
                type: Object, // ForumPost
            },

            answerPost: {
                type: Object, // ForumPost
            },

            // `post` is liked by the current user
            isLiked: {
                type: Boolean,
                default: false,
            },

            // `post` is marked as the answer
            isAnswer: {
                type: Boolean,
                default: false,
            },

            // Show the "share link to" button
            canShare: {
                type: Boolean,
                default: false,
            },

            // Show the like button
            canLike: {
                type: Boolean,
                default: true,
            },

            // Show the reply button
            canReply: {
                type: Boolean,
                default: true,
            },

            // Show the edit button
            canEdit: {
                type: Boolean,
                default: false,
            },

            // Show the delete button
            canDelete: {
                type: Boolean,
                default: false,
            },

            // Show the "mark as answer" button, as well the "remove answer"
            // button for `answerPost`
            canSolve: {
                type: Boolean,
                default: false,
            },

            // Render content inside html editor
            isEditing: {
                type: Boolean,
                default: false,
            },
        },

        components: {
            HtmlEditor,
            ForumAvatar,
            ForumPostBlock,
            ForumShare,
            LightboxMediaGallery,
        },

        data() {
            return {
                linkShareShowing: false,
                isDeleting: false,
                lightbox: {
                    showing: false,
                    media: [],
                    index: 0,
                },
            };
        },

        mounted() {
            if (this.isEditing) {
                this.initEditor();
            } else {
                this.updateLightboxMedia();
            }
        },

        methods: {
            onContentClick(ev) {
                if (this.lightbox.showing) {
                    return;
                }

                const $target = $(ev.target);

                const isImage = $target.is('img');
                const lbIndex = $target.data('lightbox-index');

                if (isImage && typeof lbIndex === 'number') {
                    this.lightbox.index = lbIndex;
                    this.lightbox.showing = true;
                }
            },

            toggleLinkShare() {
                this.linkShareShowing = !this.linkShareShowing;
                if (this.linkShareShowing) {
                    this.$nextTick(() => {
                        this.$refs.linkShare.highlight();
                    });
                }
            },

            closeLinkShare() {
                this.linkShareShowing = false;
            },

            toggleLike() {
                if (this.isLiked) {
                    this.$emit('unlike');
                } else {
                    this.$emit('like');
                }
            },

            startReply() {
                this.$emit('reply');
            },

            startEdit() {
                this.$emit('edit');
            },

            cancelEdit() {
                this.$emit('cancel');
            },

            saveEdit() {
                this.$emit('save', {
                    content: this.getContent(),
                    contentFiles: this.getContentFiles(),
                });
            },

            startDelete() {
                this.isDeleting = true;
            },

            cancelDelete() {
                this.isDeleting = false;
            },

            doDelete() {
                this.$emit('delete');
            },

            toggleAnswer() {
                if (this.isAnswer) {
                    this.$emit('unsolve');
                } else {
                    this.$emit('solve');
                }
            },

            goToSourcePost() {
                this.$emit('go-source-post');
            },

            goToAnswerPost() {
                this.$emit('go-answer-post');
            },

            initEditor() {
                if (this.$refs.editor) {
                    this.$refs.editor.setContent(this.post.content);
                    this.$refs.editor.focus();
                }
            },

            getContent() {
                if (this.isEditing && this.$refs.editor) {
                    return this.$refs.editor.getContent();
                } else {
                    return this.post.content;
                }
            },

            getContentFiles() {
                if (this.isEditing && this.$refs.editor) {
                    return this.$refs.editor.getContentFiles();
                } else {
                    return [];
                }
            },

            getAuthorName(author) {
                if (author && author.name) {
                    return author.name;
                } else {
                    return 'Anonymous';
                }
            },

            getAuthorRole(author) {
                return UserUtils.getDisplayRole({
                    roles: author.roles,
                    currentTerm: author.currentTerm,
                });
            },

            getAuthorRoleIcon(author) {
                return UserUtils.getDisplayRoleIcon({
                    roles: author.roles,
                    currentTerm: author.currentTerm,
                });
            },

            getAuthorAvatar(author) {
                if (author && author.avatarUrl) {
                    return author.avatarUrl;
                } else {
                    return null;
                }
            },

            getAuthorUrl(author) {
                if (author && author.id) {
                    return {
                        name: 'forum-user',
                        params: {
                            userId: author.id,
                        },
                    };
                } else {
                    return '';
                }
            },

            hasBeenEdited(post) {
                return (post &&
                        post.createdAt &&
                        post.updatedAt &&
                        post.createdAt.getTime() !== post.updatedAt.getTime());
            },

            hasBeenDeleted(post) {
                return !!post.deletedAt;
            },

            editStatus(post) {
                if (this.hasBeenEdited(post)) {
                    const d = ForumUtils.formatFullDate(post.updatedAt);
                    return `Edited on ${d}`;
                } else {
                    return 'Never edited';
                }
            },

            deleteStatus(post) {
                if (this.hasBeenDeleted(post)) {
                    const d = ForumUtils.formatFullDate(post.deletedAt);
                    return `Deleted on ${d}`;
                } else {
                    return 'Never deleted';
                }
            },

            postStatus(post) {
                if (post && post.createdAt) {
                    const d = ForumUtils.formatFullDate(post.createdAt);
                    return `Posted on ${d}`;
                } else {
                    return 'Not posted yet';
                }
            },

            prettyPostDate(post) {
                if (post && post.createdAt) {
                    return ForumUtils.formatRecentDate(post.createdAt);
                } else {
                    return 'Not posted yet';
                }
            },

            updateLightboxMedia() {
                const $content = $(this.$refs.content);

                let newMedia = [];

                $content.find('img:not([data-emoji])').each(function() {
                    const $img = $(this);

                    $img.data('lightbox-index', newMedia.length);

                    const $figure = $img.closest('figure');
                    const $figcap = $figure.children('figcaption');
                    const caption = $figcap.text() || $img.attr('alt');

                    newMedia.push({
                        type: 'image',
                        url: $img.attr('src'),
                        caption,
                    });
                });

                $content.find('video').each(function() {
                    const $video = $(this);

                    const $figure = $video.closest('figure');
                    const $figcap = $figure.children('figcaption');
                    const caption = $figcap.text() || $video.attr('alt');

                    newMedia.push({
                        type: 'video',
                        url: $video.attr('src'),
                        caption,
                    });
                });

                $content.find('iframe').each(function() {
                    const $iframe = $(this);

                    const $figure = $iframe.closest('figure');
                    const $figcap = $figure.children('figcaption');
                    const caption = $figcap.text();

                    newMedia.push({
                        type: 'iframe',
                        html: $iframe[0].outerHTML,
                        caption,
                    });
                });

                this.lightbox.media = newMedia;
            },
        },

        watch: {
            isEditing() {
                if (this.isEditing) {
                    this.$nextTick(this.initEditor);
                } else {
                    this.updateLightboxMedia();
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .forum-post {
        display: flex;
        background-color: #222;
        margin: 20px;
    }

    .post-body {
        margin: 17px 12px 0;
        min-width: 0;
        flex: 1;

        .post-meta {
            display: flex;

            .post-context {
                flex: 1;
                display: flex;

                .author-name {
                    color: #b0b0b0;
                    font-weight: bold;
                    margin-right: 11px;

                    &:hover {
                        color: #33ccff;
                        text-decoration: none;
                    }
                }

                .author-role {
                    opacity: 0.6;

                    img {
                        opacity: 0.8; // Even darker
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }

        .post-date {
            .edit-status {
                margin-right: 5px;
            }
            .delete-status {
                margin-right: 5px;
            }
        }

        .post-content {
            margin-top: 15px;
        }

        .post-actions {
            margin-top: 30px;
            text-align: right;

            button {
                background: none;
                border: none;
                padding: 0 10px;
                height: 35px;
                line-height: 35px;
                min-width: 35px;

                &:hover,
                &.accent-hover {
                    background: rgba(192, 192, 192, 0.12);
                }

                &.accent {
                    color: #33ccff;
                }

                &.accent-answer {
                    color: rgb(63, 235, 155);
                }

                &.btn-primary {
                    background: #33ccff;
                    border: 1px solid black;
                    color: black;
                    line-height: 33px;

                    &:hover {
                        background: black;
                        border: 1px solid #33ccff;
                        color: white;
                    }

                    i {
                        font-size: 16px;
                        margin-right: 3px;
                    }
                }

                &.btn-danger {
                    background: #ee3e34;
                    border: 1px solid black;
                    color: white;
                    line-height: 33px;

                    &:hover {
                        background: black;
                        border: 1px solid #ee3e34;
                    }
                }

                i {
                    font-size: 18px;
                }
            }
        }
    }

    .forum-avatar {
        margin-top: 19px;
        flex: none;
    }

    .forum-post-block {
        margin: 20px 0;

        .intro-icon {
            font-size: 16px;
            margin-right: 8px;
        }

        .intro-text {
            margin-right: 3px;
        }

        .avatar-small > .forum-avatar {
            width: 20px;
            height: 20px;
            font-size: 18px;
            //margin-right: 5px;
            margin: 0 5px;
        }

        .author-name {
            font-weight: bold;
        }

        p:last-of-type {
            margin-bottom: 0;
        }
    }

    .forum-post-deleted {
        padding-left: 50px;

        .post-body {
            display: flex;
            opacity: 0.6;

            .post-content {
                margin-top: 0;
                flex: 1;
            }
        }
    }

    .link-share-wrapper {
        position: relative;
        display: inline-block;

        .forum-share {
            position: absolute;
            top: -50px; // height of forum share + 6px padding
            right: 0;
            width: 300px;
        }
    }
</style>

<style lang="scss">
    // Welp, .forum-post-result is going in here since we abused the result
    // component for the LatestPosts widget and the ForumUser component.
    .forum-post,
    .forum-post-result {

        .post-content-html {
            word-wrap: break-word;

            h3 {
                margin: 50px 0 30px;
            }

            h4 {
                margin: 40px 0 20px;
                font-size: 20px;
            }

            p {
                font-size: 14px;
                line-height: 1.6;
                margin: 0 0 20px 0;

                // Keep full line height even when empty
                &:empty::before {
                    content: '';
                    display: inline-block;
                }
            }

            li > p {
                margin: 0 0 10px 0;
            }

            > ul, > ol {
                margin: 0 0 20px 0 !important;
            }

            figure {
                margin: 30px auto 20px;

                > video,
                .iframe-spacer {
                    width: 100%;
                    height: auto;
                }

                > img,
                > video,
                .iframe-wrapper {
                    border: 4px solid #363636;
                }

                > img {
                    display: block;
                    margin: 0 auto;
                    height: auto;
                }

                .iframe-wrapper {
                    background: black;
                }

                iframe {
                    border: none;
                }
            }

            figcaption {
                color: #b0b0b0;
                font-size: 14px;
                font-style: italic;

                // TODO: we can probably simplify this by removing bottom
                // padding, adding extra bottom margin to the figure, and then
                // simply hiding the figcaption if it's empty.

                &.empty {
                    // The figure's margin is a bit lopsided to account for a
                    // caption, so let's help account for the difference here.
                    height: 10px;
                }

                &:not(.empty) {
                    margin-top: 10px;
                    padding: 10px 10px 10px 35px;
                    position: relative;

                    &::before {
                        content: '\2014';
                        position: absolute;
                        left: 10px;
                    }
                }
            }

            img {
                cursor: pointer; // Opens lightbox
                display: block;
                margin: 0 0 20px;
            }

            .emoji {
                cursor: default;
                display: inline;
                margin: 0;
                width: 20px;
            }
        }

        /* The old forum posts were styled very... creatively? Lol, users would
         * attach color and background colors and all sorts of madness to the
         * text inside their posts. This looks janky in the new system, so the
         * following styles are used to normalize things a little bit.
         *
         * TODO: fix through content migration and remove these.
         */
        .post-content-html {
            * {
                color: #b0b0b0;
                background: none !important;
            }

            p[style*="color:"] {
                color: #b0b0b0 !important;
            }

            a {
                color: #33ccff;
            }
        }

        .html-editor {
            figcaption.empty {
                margin-top: 10px;
                padding: 10px 10px 10px 35px;
                position: relative;
                height: auto;

                &::before {
                    content: '\2014.';
                    position: absolute;
                    left: 10px;
                }
                &::after {
                    content: 'No caption.';
                    position: absolute;
                    top: 10px;
                    left: 35px;
                    cursor: text;
                }
            }
        }
    }

    .forum-post-block {
        .meta .context {
            display: flex;
            align-items: center;
        }
        .actions {
            // This is a bit of an experiment, but it'd be nice to make the
            // hitbox areas of the action buttons as large as possible, without
            // having to redo the CSS of the surrounding elements every time we
            // make an adjustment.
            //
            // To accomplish this, we remove the action buttons from flow using
            // height=0 and overflow=visible; then we can make the buttons any
            // size we like without affecting the elements around them. Beyond
            // that, simple relative positioning is all we need, and the
            // elements within the actions div will still react to one another
            // as expected.
            height: 0;
            overflow: visible;

            button {
                background: none;
                border: none;
                color: #a0a0a0;
                padding: 4px 5px;
                position: relative;
                top: -5px;
                right: -5px;
                font-size: 16px;

                &:hover {
                    background: rgba(192, 192, 192, 0.12);
                }
            }
        }
        .content {
            margin-top: 10px;
        }

        // NOTE: the following CSS contains changes to temporarily make the
        // whole post block clickable, and to act as the "go to post" button.
        // This can be changed back once post blocks are fully implemented (ie.
        // they are no longer just stubs).
        position: relative;
        .content {
            margin-top: 0px;
        }
        .actions {
            button {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                padding: 0;

                i {
                    position: absolute;
                    right: 16px;
                    top: 16px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// post.vue?40f878dd